module.exports = __webpack_public_path__ + "img/10.d577e199.png";